import './FilterViewTemplate.less';
import React from 'react';
import {translate} from "../../../../i18n";
import operatorLabels from "../../config/operatorLabels";


export default function FilterViewTemplate({fieldName, operator, value, valueLabel, requestEdit}) {

    return <div
        className={'filter-view-template' + (requestEdit ? ' editable' : '')}
        title={requestEdit ? translate('Click to edit') : undefined}
        onClick={requestEdit}
    >
        <div className="field">
            {fieldName}
        </div>

        <div
            className="operator"
            dangerouslySetInnerHTML={{__html: operatorLabels[operator]}}
        />

        <div
            className="value"
            aria-label={valueLabel}
            aria-controls="tooltip-is-plain-text-content"
        >
            {value}
        </div>
    </div>;
}
